module.exports = __webpack_public_path__ + "img/img-3400-xs@2x.82fa7e82.jpg";